var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownloadIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 17,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#0B0A06",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M14.75 10.754v2.667a1.334 1.334 0 0 1-1.333 1.333H4.083A1.334 1.334 0 0 1 2.75 13.42v-2.667"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#0B0A06",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m5.416 7.422 3.333 3.333 3.334-3.333M8.75 10.754v-8"
})));
export default SvgDownloadIcon;